import { useContext } from 'react';

import { AuthContext } from '../../auth/AuthContext';
import { AuthContextType } from '../../auth/types';

const useAuth = (): AuthContextType => {
  return useContext(AuthContext);
};

export default useAuth;
